// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3VcWl","header":"ReportDetails_header__1eKgI","title":"ReportDetails_title__1xvVf","left":"ReportDetails_left__aZvyY"};